<template>
  <table-view :total="total" :query-info.sync="queryInfo" @reload-table="renderTable">
    <template #header>
      <view-search-form :queryInfo.sync="queryInfo" keyword-placeholder="姓名，身份证" :tool-list="['grade', 'keyword']"
                        @on-search="renderTable(1)">
        <el-form-item label="自定义非全日制专业" label-width="170">
          <el-select v-model="queryInfo.majorName" clearable filterable size="small" style="width: 260px;">
            <el-option v-for="majorName in customizedMajorList" :key="majorName" :label="majorName" :value="majorName" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否已缴费" label-width="130" prop="payFlag">
          <el-select v-model="queryInfo.payFlag" clearable size="small" style="width: 100px;">
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </el-form-item>
      </view-search-form>
      <div class="header-button">
        <el-button type="success" plain size="small" @click="handleDownloadStuList()">导出自定义非全日制缴费</el-button>
        <template v-permission="['partTime:pay:add']">
          <upload-excel :permit-key="['partTime:pay:add']"
                        :loading.sync="loading"
                        :api="$http.importExcelHttp.importPartTimePayment"
                        @on-download="$http.exportExcelHttp.exportPartTimePaymentTemplate()"
                        @on-success="renderTable(1)" />
          <el-divider direction="vertical"/>
          <upload-excel :permit-key="['partTime:pay:add']"
                        :loading.sync="loading"
                        import-title="批量更新数据"
                        import-btn-type="success"
                        :show-download="false"
                        :api="$http.importExcelHttp.updatePartTimePayment"
                        @on-success="renderTable(1)" />
          <el-button type="primary" size="small" @click="showDialog()">添加自定义非全日制缴费
          </el-button>
        </template>
      </div>
    </template>
    <!-- body -->
    <el-table :data="tableData" style="width: 100%" border stripe>
      <el-table-column prop="orderNo" label="学费订单" width="220" align="center" fixed="left" />
      <el-table-column prop="payFlag" label="状态" width="90" align="center">
        <template v-slot="{ row }">
          <el-tag v-if="+row.payFlag" type="success">已缴</el-tag>
          <span class="info" v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="academicYear" label="缴费学年" width="100" align="center">
        <template v-slot="{ row }">
          第{{ chineseNum[+row.academicYear || 0] }}学年
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="缴费标准" width="100" />
      <el-table-column prop="collegeName" label="二级学院" width="120" />
      <el-table-column prop="majorName" label="专业名字" width="250" />
      <el-table-column prop="stuName" label="姓名" width="120" />
      <el-table-column prop="grade" label="年级" width="120" />
      <el-table-column prop="idNumber" label="身份证" width="180" />
      <el-table-column prop="examineCode" label="考生号" width="140" />
      <el-table-column prop="teachAddress" label="教学点" width="200" />
      <el-table-column prop="admissionOfficer" label="招生老师" width="140" />
      <el-table-column prop="remarks" label="备注" min-width="150" />
      <el-table-column label="操作" fixed="right" width="220">
        <template v-slot="{ row }">
          <el-button v-permission="['partTime:pay:edit']" type="primary" size="mini"
                     @click="showDialog(row.id, `-${row.stuName}(${row.examineCode})`)">编辑
          </el-button>
          <el-button v-permission="['partTime:pay:edit']" type="primary" size="mini"
                     @click="resetPassword(row)">重置密码
          </el-button>
          <el-button v-permission="['partTime:pay:del']" size="mini" type="danger"
                     @click="del(delPartTimePaymentByIdApi, row.id, `自定义非全日制缴费-${row.stuName}(考号:${row.examineCode})`)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <PartTimePaymentDialog ref="dialogRef" :visible.sync="visibleDialog" v-if="visibleDialog"
                           @on-close="renderTable" />
  </table-view>
</template>

<script>
import {
  getPartTimeMajorsCustomized, resetStudentPartTimePasswordApi
} from '@/api/studentPartTime'
import tableView from '@/vue/mixins/table-view'
import { delPartTimePaymentByIdApi, pagePartTimePaymentApi } from '@/api/part-time/part-time-payment-api'
import PartTimePaymentDialog from '@/views/pages/stuInfoPartTime/part-time-payment/component/PartTimePaymentDialog.vue'

export default {
  name: 'PartTimePayment',
  components: {
    PartTimePaymentDialog
  },
  mixins: [tableView],
  data() {
    return {
      chineseNum: '零一二三四五六七',
      queryInfo: {
        payFlag: null,
        grade: new Date().getFullYear(),
        majorName: null
      },
      customizedMajorList: []
    }
  },
  created() {
    this.getMajorListCustomized()
    this.renderTable(1)
  },
  methods: {
    delPartTimePaymentByIdApi, // 删除api
    // 获取学生列表
    renderTable(pageNum) {
      this.getTableData(pagePartTimePaymentApi, pageNum)
    },
    // 获取继续教育专业 list 专用于自定义非全日制缴费
    async getMajorListCustomized() {
      try {
        const { data } = await getPartTimeMajorsCustomized()
        this.customizedMajorList = data
      } catch (e) {
        console.error(e)
      }
    },
    getTag(type) {
      if (type === 1) {
        return '<span class="el-tag el-tag--success el-tag--light">已缴</span>'
      } else {
        return '<span class="el-tag el-tag--info el-tag--light">未缴</span>'
      }
    },
    // 重置密码
    resetPassword(row) {
      this.$confirm(`是否确定重置非全日制学生 <b style="color:var(--color-primary)">${row.stuName}(${row.examineCode})</b> 的密码？`, '重置密码', {
        dangerouslyUseHTMLString: true
      }).then(async () => {
        try {
          await resetStudentPartTimePasswordApi(row.id)
          this.$message.success(`账号${row.stuName}(${row.examineCode})的密码已成功重置为 身份证后六位,为保障账号安全,请尽快修改密码!`)
        } catch (e) {
          console.error(e)
        }
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    handleDownloadStuList() {
      this.$http.exportExcelHttp.downloadPartTimePayment(this.queryInfo, '自定义非全日制缴费').then()
    }
  }
}
</script>
